module.exports = __webpack_public_path__ + "static/media/external-link-icon.54e7f464.svg";